import {createStore} from 'vuex'
export default createStore({
  state: {
    token:'',
    seller:{},
    todos:[],
    whome:{},
	position:'',
    config:{},
    dqpath:'',
    weborder:null,
    todoone:null,
	chatcount:0,
    sellersoc:false,
  },
  mutations: {
    SET_TOKEN: (state, token) => {
    state.token = token
    },
    setsellersoc(state,val){
      state.sellersoc=val
    },
	setposition(state,position){
	  state.position=position;
	  //state.storeseller.table=position
	},
	setchatcount(state,val){
		if(val==0){
			state.chatcount=0;
		}else{
			state.chatcount+=1;
		}
	},
    setweborder(state,val){
      state.weborder=val
    },
    setwhome(state,val){
      state.whome=val
    },
    setconfig(state,val){
      state.config=val
    },
    setseller(state,val){
      state.seller=val
    },
    settodoone(state,val){
      state.todoone=val
    },
    setpath(state,val){
      state.dqpath=val
    },
    addtodos (state,val) {
      if(Array.isArray(val)){
        Vue.set(state,'todos',val);
      }else {
        var res = -1;
        for(var i=0;i<state.todos.length;i++){
          if(state.todos[i].id==val.id){
            res=i;
            break;
          }
        }
        if(res == -1){
          state.todos.push(val)
        }else {
          state.todos[res].count+=1;
        }
      }
    },
    removetodos(state,val){
      // console.log(val);
      if(val.id){
        // console.log('val has id');
        var res = -1;
        for(var i=0;i<state.todos.length;i++){
          if(state.todos[i].id==val.id){
            res=i;
            state.todos.splice(res,1);
            break;
          }
        }
      }else{
        // console.log('todos is empty');
        Vue.set(state,'todos',[]);
        // state.todos.length=0;
      }
    }
  },
  getters:{
	gettable:state=>{return state.position},
    getpath:state=>{
      return state.dqpath;
    },
	getchatcount:state=>{
		return state.chatcount;
	},
    gettodobyid: (state) => (id) => {
    return state.todos.find(todo => todo.id == id)
    },
    gettodoone:state=>{
      return state.todoone;
    },
    getweborder:state=>{
      return state.weborder;
    },
    sellersoc:state=>{
      return state.sellersoc;
    },
    getwhome:state=>{
      return state.whome;
    },
    dlcount:state=>{
      var count=0
      state.todos.forEach((one)=>{
        count+=one.count;
      })
      return count;
    },
    dlallprice:state=>{
      var allprice=0
      state.todos.forEach((one)=>{
        allprice+=one.count*one.price;
      })
      return allprice;
    },
    dlsize:state=>{
      return state.todos.length;
    },
    gettodos:state=>{
      return state.todos;
    },
    getseller:state=>{
      return state.seller;
    }
  },
  actions: {

  }
})
